import { ISubjectValue, ISubjectFieldValue } from "@/consts/interfaces";

// 教科（中学校用）
const SUBJECTS: Array<ISubjectValue> = [
    {name: "国語", value: "kokugo"},
    {name: "社会", value: "shakai"},
    {name: "数学", value: "sugaku"},
    {name: "理科", value: "rika"},
    {name: "英語", value: "eigo"}
]

const SUBJECTFIELDS: Array<ISubjectFieldValue> = [
    {name: "国語", value: "kokugo", root: "kokugo"},
    {name: "社会", value: "shakai", root: "shakai"}, // NFR-7107 社会を追加 / NFR-7302 社会科目の教材をまとめるため国語の直後に移動
    {name: "地理", value: "chiri", root: "shakai"},
    {name: "歴史", value: "rekishi", root: "shakai"},
    {name: "公民", value: "komin", root: "shakai"},
    {name: "数学", value: "sugaku", root: "sugaku"},
    {name: "算数", value: "sansu", root: "sansu"},
    {name: "理科", value: "rika", root: "rika"},
    {name: "英語", value: "eigo", root: "eigo"},
]

const SUBJECT_ALL: ISubjectValue = {name: "総合", value: "all"}

const SUBJECT_MAP: { [id: string] : string } = {
    "国語": "kokugo",
    "社会": "shakai",
    "数学": "sugaku",
    "理科": "rika",
    "英語": "eigo",
    "算数": "sansu",
}

const SUBJECTFIELD_MAP: { [id: string] : string } = {
    "国語": "kokugo",
    "地理": "chiri",
    "歴史": "rekishi",
    "公民": "komin",
    "数学": "sugaku",
    "理科": "rika",
    "英語": "eigo",
    "算数": "sansu",
    "社会": "shakai",
}

const SUBJECTFIELD_READING_MAP: { [id: string] : string } = {
    "国語": "こくご",
    "社会": "しゃかい",
    "地理": "ちり",
    "歴史": "れきし",
    "公民": "こうみん",
    "数学": "すうがく",
    "算数": "さんすう",
    "理科": "りか",
    "英語": "えいご",
}

const SUBJECTFIELD_SORT_MAP: {[id: string] : number} = {
    "地理": 0,
    "歴史": 1,
    "公民": 2,
}

const SOCIETY_SUBJECT_FIELD = {
    SHAKAI: "社会",
    CHIRI: "地理",
    REKISHI: "歴史",
    KOMIN: "公民"
}

const SUBJECTFIELD_ORDER_MAP: { [id: string] : number } = {
    "国語": 0,
    "地理": 1,
    "歴史": 2,
    "公民": 3,
    "数学": 4,
    "理科": 5,
    "英語": 6,
}

const SUBJECT_ID_MAP: { [value: string] : number } = {
      "all": 0,
      "kokugo": 1,
      "shakai": 2,
      "sugaku": 3,
      "rika": 4,
      "eigo": 5,
    }

const SUBJECTFIELD_ID_MAP: { [value: string] : number } = {
    "kokugo": 1,
    "chiri": 2,
    "rekishi": 3,
    "komin": 4,
    "sugaku": 5,
    "rika": 6,
    "eigo": 7,
}

const VALID_SUBJECT_NAME: Array<string> = [
    "kokugo",
    "shakai",
    "sugaku",
    "rika",
    "eigo",
]

const SUBJECTFIELD_LOGGER_MAP: { [value: string] : string } = {
    "国語": "KK",
    "社会": "SK",
    "地理": "CR",
    "歴史": "RS",
    "公民": "KM",
    "数学": "SG",
    "理科": "RK",
    "英語": "EI",
}

export {
    SUBJECTS,
    SUBJECTFIELDS,
    SUBJECT_ALL,
    SUBJECT_MAP,
    SUBJECTFIELD_MAP,
    SUBJECTFIELD_READING_MAP,
    SUBJECTFIELD_SORT_MAP,
    SOCIETY_SUBJECT_FIELD,
    SUBJECTFIELD_ORDER_MAP,
    SUBJECT_ID_MAP,
    SUBJECTFIELD_ID_MAP,
    VALID_SUBJECT_NAME,
    SUBJECTFIELD_LOGGER_MAP,
}
